// InstructionsArchivePanel is where the remaining instructions are
// displayed.

import { INSTRUCTIONS_ORDER } from 'app/src/engine/Instruction';
import InstructionCountNode from 'app/src/game/InstructionCountNode';
import { useInstructionsArchiveContext } from 'app/src/game/InstructionsArchiveContext';
import { useProgramStoreContext } from 'app/src/game/ProgramStoreContext';
import * as React from 'react';

export default function InstructionsArchivePanel(): React.ReactElement | null {
	const { addInstruction } = useProgramStoreContext();
	const { instructionCounts, setInstructionCount } = useInstructionsArchiveContext();

	return (
		<div className="InstructionsArchivePanel">
			<div className="InstructionsArchivePanel-innerContainer">
				{INSTRUCTIONS_ORDER.map((type) => {
					if (!instructionCounts.has(type)) {
						return null;
					}

					const onClick = (): void => {
						if (!instructionCounts.has(type)) {
							return;
						}

						const currentCount = instructionCounts.get(type) || 0;

						if (currentCount !== 0) {
							setInstructionCount(type, currentCount - 1);
							addInstruction(type);
						}
					};

					return (
						<div
							className="InstructionsArchivePanel-instructionCountNodeContainer"
							key={'instructionCountNodeContainer--' + type}
						>
							<InstructionCountNode
								type={type}
								count={instructionCounts.get(type) || 0}
								onClick={onClick}
							/>
						</div>
					);
				}).filter(Boolean)}
			</div>
		</div>
	);
}
